export default "__VITE_ASSET__BOLv9WyT__"